module.exports = __webpack_public_path__ + "static/media/SBN.87ea79f1.png";